import React, {useCallback, useEffect, useState} from "react"
import {useTranslation} from "react-i18next"
import Heading from "../../../../components/Heading"
import {api, ApiRoutes} from "../../../../services/ApiService"
import {HtaccessStatus} from "../../../../types/HtaccessData"
import Button from "../../../../components/Button"
import Loader from "../../../../components/Loader"
import cx from "classnames"
import styles from './HtaccessForm.module.scss'
import {showToast} from "../../../../services/ToastService";

const HtaccessForm: React.FC = () => {
    const { t } = useTranslation(['settings'])

    const [status, setHtaccessStatus] = useState<HtaccessStatus>({
        modified: false,
        backupExists: false,
        modifier_string: '',
        url: '',
        errors: []
    })

    const [isLoading, setLoading] = useState<boolean>(false)

    useEffect(() => {
        setLoading(true)
        api.get(ApiRoutes.HTACCESS_CHECK).then((res) => {
            setLoading(false)
            setHtaccessStatus(res.data.data)
        })
    }, [])

    const modify = useCallback(() => {
        setLoading(true)
        api.get(ApiRoutes.HTACCESS_MODIFY).then((res) => {
            setLoading(false)
            setHtaccessStatus(prev => (
                {
                    ...prev,
                    backupExists: res.data.data.backupExists,
                    modified: res.data.data.modified
                }
            ))
            if (res.data.data.success) {
                showToast(t('htaccess.modified'))
            } else {
                showToast(t('htaccess.error') + ": " + res.data?.message, 'error')
            }
        })
    }, [])

    const restore = useCallback(() => {
        setLoading(true)
        api.get(ApiRoutes.HTACCESS_RESTORE).then((res) => {
            setLoading(false)
            setHtaccessStatus(prev => (
                {
                    ...prev,
                    backupExists: res.data.data.backupExists,
                    modified: res.data.data.modified
                }
            ))
            if (res.data.data.success) {
                showToast(t('htaccess.restored'))
            } else {
                showToast(t('htaccess.error') + ": " + res.data?.message, 'error')
            }
        })
    }, [])

    return (
        <>
            <Heading level={4} classes={'zr-my-4'}>
                {t('htaccess.heading')}
            </Heading>
            <p style={{maxWidth: 1000}}>Es besteht die Möglichkeit, den Customizer über <code><a target={"_blank"} href={status.url}>{status.url}</a></code> aufzurufen und sich mit einen Backend Account oder Fulfiller Account einzuloggen. Falls dies nicht möglich ist, muss die <code>.htaccess</code> Datei im Shop Root Verzeichnis angepasst werden.</p>
            {status &&
                <div>
                    <Heading classes={'zr-mt-4'} level={4}>Automatische Anpassung <code>.htaccess</code> im Shop Root Verzeichnis</Heading>
                    {!status.modified ?
                        <Button
                            disabled={isLoading}
                            hierarchy={'primary'}
                            text={t('htaccess.modify')}
                            fn={() => modify()}
                        />
                        :
                        <div>
                            <div style={{color: 'green'}} className={'zr-mb-3'}><b><code>.htaccess</code> angepasst</b></div>
                            {status.backupExists &&
                                <Button
                                    disabled={isLoading}
                                    hierarchy={'primary'}
                                    text={t('htaccess.restore')}
                                    fn={() => restore()}
                                />
                            }
                        </div>
                    }

                    <Heading classes={'zr-mt-4'} level={4}>Manuelle Anpassung <code>.htaccess</code> im Shop Root Verzeichnis</Heading>
                    Nach dieser Zeile
                    <pre style={{backgroundColor: '#f1f1f1'}} className={'zr-px-4 zr-py-3'}>
                        RewriteEngine on
                    </pre>
                    müssen folgende Zeilen
                    <pre style={{backgroundColor: '#f1f1f1'}} className={'zr-px-4'}>
                        {status.modifier_string.replace(/\\n/g, "\n")}
                    </pre>
                    eingefügt werden.
                </div>
            }
            {isLoading &&
                <div className={cx(styles['zr-loader-wrapper'])}>
                    <Loader isLoading={true} />
                </div>
            }
        </>
    )

}

export default HtaccessForm
